export const THEME_PREFERENCE_KEY = "premiumblog:theme-preference";

const DARK_THEME_VALUE = "#0b1118";

export const getThemePreferenceFromPersistedState = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const persistedRoot = window.localStorage.getItem("persist:root");

    if (!persistedRoot) {
      return null;
    }

    const parsedRoot = JSON.parse(persistedRoot);
    const persistedAppState = parsedRoot?.appState ? JSON.parse(parsedRoot.appState) : null;
    const persistedTheme = persistedAppState?.appTheme || parsedRoot?.appTheme;

    if (persistedTheme === DARK_THEME_VALUE) {
      return "dark";
    }

    if (persistedTheme === "white") {
      return "light";
    }
  } catch (error) {
    console.error(error);
  }

  return null;
};

export const getSavedThemePreference = () => {
  if (typeof window === "undefined") {
    return "light";
  }

  const explicitPreference = window.localStorage.getItem(THEME_PREFERENCE_KEY);

  if (explicitPreference === "dark" || explicitPreference === "light") {
    return explicitPreference;
  }

  return getThemePreferenceFromPersistedState() || "light";
};

export const saveThemePreference = (preference) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(THEME_PREFERENCE_KEY, preference === "dark" ? "dark" : "light");
};
